var _toConsumableArray = require("/Users/rishavanand/Projects/Exponents/virtooally-event/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/Users/rishavanand/Projects/Exponents/virtooally-event/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/Users/rishavanand/Projects/Exponents/virtooally-event/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _asyncToGenerator = require("/Users/rishavanand/Projects/Exponents/virtooally-event/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/rishavanand/Projects/Exponents/virtooally-event/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/Users/rishavanand/Projects/Exponents/virtooally-event/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/Users/rishavanand/Projects/Exponents/virtooally-event/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/rishavanand/Projects/Exponents/virtooally-event/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _wrapNativeSuper = require("/Users/rishavanand/Projects/Exponents/virtooally-event/node_modules/@babel/runtime/helpers/wrapNativeSuper");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var querystring = require('querystring');

var sax = require('sax');

var miniget = require('miniget');

var utils = require('./utils'); // Forces Node JS version of setTimeout for Electron based applications


var _require = require('timers'),
    setTimeout = _require.setTimeout;

var formatUtils = require('./format-utils');

var urlUtils = require('./url-utils');

var extras = require('./info-extras');

var sig = require('./sig');

var Cache = require('./cache');

var BASE_URL = 'https://www.youtube.com/watch?v='; // Cached for storing basic/full info.

exports.cache = new Cache();
exports.cookieCache = new Cache(1000 * 60 * 60 * 24);
exports.watchPageCache = new Cache(); // Cache for cver used in getVideoInfoPage

var cver = '2.20210622.10.00'; // Special error class used to determine if an error is unrecoverable,
// as in, ytdl-core should not try again to fetch the video metadata.
// In this case, the video is usually unavailable in some way.

var UnrecoverableError = /*#__PURE__*/function (_Error) {
  "use strict";

  _inherits(UnrecoverableError, _Error);

  var _super = _createSuper(UnrecoverableError);

  function UnrecoverableError() {
    _classCallCheck(this, UnrecoverableError);

    return _super.apply(this, arguments);
  }

  return UnrecoverableError;
}( /*#__PURE__*/_wrapNativeSuper(Error)); // List of URLs that show up in `notice_url` for age restricted videos.


var AGE_RESTRICTED_URLS = ['support.google.com/youtube/?p=age_restrictions', 'youtube.com/t/community_guidelines'];
/**
 * Gets info from a video without getting additional formats.
 *
 * @param {string} id
 * @param {Object} options
 * @returns {Promise<Object>}
*/

exports.getBasicInfo = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(id, options) {
    var retryOptions, validate, info, media, additional;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            retryOptions = Object.assign({}, miniget.defaultOptions, options.requestOptions);
            options.requestOptions = Object.assign({}, options.requestOptions, {});
            options.requestOptions.headers = Object.assign({}, {
              // eslint-disable-next-line max-len
              'User-Agent': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/87.0.4280.101 Safari/537.36'
            }, options.requestOptions.headers);

            validate = function validate(info) {
              var playErr = utils.playError(info.player_response, ['ERROR'], UnrecoverableError);
              var privateErr = privateVideoError(info.player_response);

              if (playErr || privateErr) {
                throw playErr || privateErr;
              }

              return info && info.player_response && (info.player_response.streamingData || isRental(info.player_response) || isNotYetBroadcasted(info.player_response));
            };

            _context.next = 6;
            return pipeline([id, options], validate, retryOptions, [getWatchHTMLPage, getWatchJSONPage, getVideoInfoPage]);

          case 6:
            info = _context.sent;
            Object.assign(info, {
              formats: parseFormats(info.player_response),
              related_videos: extras.getRelatedVideos(info)
            }); // Add additional properties to info.

            media = extras.getMedia(info);
            additional = {
              author: extras.getAuthor(info),
              media: media,
              likes: extras.getLikes(info),
              dislikes: extras.getDislikes(info),
              age_restricted: !!(media && media.notice_url && AGE_RESTRICTED_URLS.some(function (url) {
                return media.notice_url.includes(url);
              })),
              // Give the standard link to the video.
              video_url: BASE_URL + id,
              storyboards: extras.getStoryboards(info),
              chapters: extras.getChapters(info)
            };
            info.videoDetails = extras.cleanVideoDetails(Object.assign({}, info.player_response && info.player_response.microformat && info.player_response.microformat.playerMicroformatRenderer, info.player_response && info.player_response.videoDetails, additional), info);
            return _context.abrupt("return", info);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var privateVideoError = function privateVideoError(player_response) {
  var playability = player_response && player_response.playabilityStatus;

  if (playability && playability.status === 'LOGIN_REQUIRED' && playability.messages && playability.messages.filter(function (m) {
    return /This is a private video/.test(m);
  }).length) {
    return new UnrecoverableError(playability.reason || playability.messages && playability.messages[0]);
  } else {
    return null;
  }
};

var isRental = function isRental(player_response) {
  var playability = player_response.playabilityStatus;
  return playability && playability.status === 'UNPLAYABLE' && playability.errorScreen && playability.errorScreen.playerLegacyDesktopYpcOfferRenderer;
};

var isNotYetBroadcasted = function isNotYetBroadcasted(player_response) {
  var playability = player_response.playabilityStatus;
  return playability && playability.status === 'LIVE_STREAM_OFFLINE';
};

var getWatchHTMLURL = function getWatchHTMLURL(id, options) {
  return "".concat(BASE_URL + id, "&hl=").concat(options.lang || 'en');
};

var getWatchHTMLPageBody = function getWatchHTMLPageBody(id, options) {
  var url = getWatchHTMLURL(id, options);
  return exports.watchPageCache.getOrSet(url, function () {
    return utils.exposedMiniget(url, options).text();
  });
};

var EMBED_URL = 'https://www.youtube.com/embed/';

var getEmbedPageBody = function getEmbedPageBody(id, options) {
  var embedUrl = "".concat(EMBED_URL + id, "?hl=").concat(options.lang || 'en');
  return utils.exposedMiniget(embedUrl, options).text();
};

var getHTML5player = function getHTML5player(body) {
  var html5playerRes = /<script\s+src="([^"]+)"(?:\s+type="text\/javascript")?\s+name="player_ias\/base"\s*>|"jsUrl":"([^"]+)"/.exec(body);
  return html5playerRes ? html5playerRes[1] || html5playerRes[2] : null;
};

var getIdentityToken = function getIdentityToken(id, options, key, throwIfNotFound) {
  return exports.cookieCache.getOrSet(key, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var page, match;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getWatchHTMLPageBody(id, options);

          case 2:
            page = _context2.sent;
            match = page.match(/(["'])ID_TOKEN\1[:,]\s?"([^"]+)"/);

            if (!(!match && throwIfNotFound)) {
              _context2.next = 6;
              break;
            }

            throw new UnrecoverableError('Cookie header used in request, but unable to find YouTube identity token');

          case 6:
            return _context2.abrupt("return", match && match[2]);

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })));
};
/**
 * Goes through each endpoint in the pipeline, retrying on failure if the error is recoverable.
 * If unable to succeed with one endpoint, moves onto the next one.
 *
 * @param {Array.<Object>} args
 * @param {Function} validate
 * @param {Object} retryOptions
 * @param {Array.<Function>} endpoints
 * @returns {[Object, Object, Object]}
 */


var pipeline = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(args, validate, retryOptions, endpoints) {
    var info, _iterator, _step, func, newInfo;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _iterator = _createForOfIteratorHelper(endpoints);
            _context3.prev = 1;

            _iterator.s();

          case 3:
            if ((_step = _iterator.n()).done) {
              _context3.next = 21;
              break;
            }

            func = _step.value;
            _context3.prev = 5;
            _context3.next = 8;
            return retryFunc(func, args.concat([info]), retryOptions);

          case 8:
            newInfo = _context3.sent;

            if (newInfo.player_response) {
              newInfo.player_response.videoDetails = assign(info && info.player_response && info.player_response.videoDetails, newInfo.player_response.videoDetails);
              newInfo.player_response = assign(info && info.player_response, newInfo.player_response);
            }

            info = assign(info, newInfo);

            if (!validate(info, false)) {
              _context3.next = 13;
              break;
            }

            return _context3.abrupt("break", 21);

          case 13:
            _context3.next = 19;
            break;

          case 15:
            _context3.prev = 15;
            _context3.t0 = _context3["catch"](5);

            if (!(_context3.t0 instanceof UnrecoverableError || func === endpoints[endpoints.length - 1])) {
              _context3.next = 19;
              break;
            }

            throw _context3.t0;

          case 19:
            _context3.next = 3;
            break;

          case 21:
            _context3.next = 26;
            break;

          case 23:
            _context3.prev = 23;
            _context3.t1 = _context3["catch"](1);

            _iterator.e(_context3.t1);

          case 26:
            _context3.prev = 26;

            _iterator.f();

            return _context3.finish(26);

          case 29:
            return _context3.abrupt("return", info);

          case 30:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[1, 23, 26, 29], [5, 15]]);
  }));

  return function pipeline(_x3, _x4, _x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}();
/**
 * Like Object.assign(), but ignores `null` and `undefined` from `source`.
 *
 * @param {Object} target
 * @param {Object} source
 * @returns {Object}
 */


var assign = function assign(target, source) {
  if (!target || !source) {
    return target || source;
  }

  for (var _i = 0, _Object$entries = Object.entries(source); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];

    if (value !== null && value !== undefined) {
      target[key] = value;
    }
  }

  return target;
};
/**
 * Given a function, calls it with `args` until it's successful,
 * or until it encounters an unrecoverable error.
 * Currently, any error from miniget is considered unrecoverable. Errors such as
 * too many redirects, invalid URL, status code 404, status code 502.
 *
 * @param {Function} func
 * @param {Array.<Object>} args
 * @param {Object} options
 * @param {number} options.maxRetries
 * @param {Object} options.backoff
 * @param {number} options.backoff.inc
 */


var retryFunc = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(func, args, options) {
    var currentTry, result;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            currentTry = 0;

          case 1:
            if (!(currentTry <= options.maxRetries)) {
              _context5.next = 14;
              break;
            }

            _context5.prev = 2;
            _context5.next = 5;
            return func.apply(void 0, _toConsumableArray(args));

          case 5:
            result = _context5.sent;
            return _context5.abrupt("break", 14);

          case 9:
            _context5.prev = 9;
            _context5.t0 = _context5["catch"](2);
            return _context5.delegateYield( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
              var wait;
              return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      if (!(_context5.t0 instanceof UnrecoverableError || _context5.t0 instanceof miniget.MinigetError && _context5.t0.statusCode < 500 || currentTry >= options.maxRetries)) {
                        _context4.next = 2;
                        break;
                      }

                      throw _context5.t0;

                    case 2:
                      wait = Math.min(++currentTry * options.backoff.inc, options.backoff.max);
                      _context4.next = 5;
                      return new Promise(function (resolve) {
                        return setTimeout(resolve, wait);
                      });

                    case 5:
                    case "end":
                      return _context4.stop();
                  }
                }
              }, _callee4);
            })(), "t1", 12);

          case 12:
            _context5.next = 1;
            break;

          case 14:
            return _context5.abrupt("return", result);

          case 15:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[2, 9]]);
  }));

  return function retryFunc(_x7, _x8, _x9) {
    return _ref4.apply(this, arguments);
  };
}();

var jsonClosingChars = /^[)\]}'\s]+/;

var parseJSON = function parseJSON(source, varName, json) {
  if (!json || typeof json === 'object') {
    return json;
  } else {
    try {
      json = json.replace(jsonClosingChars, '');
      return JSON.parse(json);
    } catch (err) {
      throw Error("Error parsing ".concat(varName, " in ").concat(source, ": ").concat(err.message));
    }
  }
};

var findJSON = function findJSON(source, varName, body, left, right, prependJSON) {
  var jsonStr = utils.between(body, left, right);

  if (!jsonStr) {
    throw Error("Could not find ".concat(varName, " in ").concat(source));
  }

  return parseJSON(source, varName, utils.cutAfterJSON("".concat(prependJSON).concat(jsonStr)));
};

var findPlayerResponse = function findPlayerResponse(source, info) {
  var player_response = info && (info.args && info.args.player_response || info.player_response || info.playerResponse || info.embedded_player_response);
  return parseJSON(source, 'player_response', player_response);
};

var getWatchJSONURL = function getWatchJSONURL(id, options) {
  return "".concat(getWatchHTMLURL(id, options), "&pbj=1");
};

var getWatchJSONPage = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(id, options) {
    var reqOptions, cookie, setIdentityToken, jsonUrl, body, parsedBody, info;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            reqOptions = Object.assign({
              headers: {}
            }, options.requestOptions);
            cookie = reqOptions.headers.Cookie || reqOptions.headers.cookie;
            reqOptions.headers = Object.assign({
              'x-youtube-client-name': '1',
              'x-youtube-client-version': cver,
              'x-youtube-identity-token': exports.cookieCache.get(cookie || 'browser') || ''
            }, reqOptions.headers);

            setIdentityToken = /*#__PURE__*/function () {
              var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(key, throwIfNotFound) {
                return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                  while (1) {
                    switch (_context6.prev = _context6.next) {
                      case 0:
                        if (!reqOptions.headers['x-youtube-identity-token']) {
                          _context6.next = 2;
                          break;
                        }

                        return _context6.abrupt("return");

                      case 2:
                        _context6.next = 4;
                        return getIdentityToken(id, options, key, throwIfNotFound);

                      case 4:
                        reqOptions.headers['x-youtube-identity-token'] = _context6.sent;

                      case 5:
                      case "end":
                        return _context6.stop();
                    }
                  }
                }, _callee6);
              }));

              return function setIdentityToken(_x12, _x13) {
                return _ref6.apply(this, arguments);
              };
            }();

            if (!cookie) {
              _context7.next = 7;
              break;
            }

            _context7.next = 7;
            return setIdentityToken(cookie, true);

          case 7:
            jsonUrl = getWatchJSONURL(id, options);
            _context7.next = 10;
            return utils.exposedMiniget(jsonUrl, options, reqOptions).text();

          case 10:
            body = _context7.sent;
            parsedBody = parseJSON('watch.json', 'body', body);

            if (!(parsedBody.reload === 'now')) {
              _context7.next = 15;
              break;
            }

            _context7.next = 15;
            return setIdentityToken('browser', false);

          case 15:
            if (!(parsedBody.reload === 'now' || !Array.isArray(parsedBody))) {
              _context7.next = 17;
              break;
            }

            throw Error('Unable to retrieve video metadata in watch.json');

          case 17:
            info = parsedBody.reduce(function (part, curr) {
              return Object.assign(curr, part);
            }, {});
            info.player_response = findPlayerResponse('watch.json', info);
            info.html5player = info.player && info.player.assets && info.player.assets.js;
            return _context7.abrupt("return", info);

          case 21:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function getWatchJSONPage(_x10, _x11) {
    return _ref5.apply(this, arguments);
  };
}();

var getWatchHTMLPage = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(id, options) {
    var body, info, args;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return getWatchHTMLPageBody(id, options);

          case 2:
            body = _context8.sent;
            info = {
              page: 'watch'
            };

            try {
              cver = utils.between(body, '{"key":"cver","value":"', '"}');
              info.player_response = findJSON('watch.html', 'player_response', body, /\bytInitialPlayerResponse\s*=\s*\{/i, '</script>', '{');
            } catch (err) {
              args = findJSON('watch.html', 'player_response', body, /\bytplayer\.config\s*=\s*{/, '</script>', '{');
              info.player_response = findPlayerResponse('watch.html', args);
            }

            info.response = findJSON('watch.html', 'response', body, /\bytInitialData("\])?\s*=\s*\{/i, '</script>', '{');
            info.html5player = getHTML5player(body);
            return _context8.abrupt("return", info);

          case 8:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function getWatchHTMLPage(_x14, _x15) {
    return _ref7.apply(this, arguments);
  };
}();

var INFO_HOST = 'www.youtube.com';
var INFO_PATH = '/get_video_info';
var VIDEO_EURL = 'https://youtube.googleapis.com/v/';

var getVideoInfoPage = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(id, options) {
    var url, body, info;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            url = new URL("https://".concat(INFO_HOST).concat(INFO_PATH));
            url.searchParams.set('video_id', id);
            url.searchParams.set('c', 'TVHTML5');
            url.searchParams.set('cver', "7".concat(cver.substr(1)));
            url.searchParams.set('eurl', VIDEO_EURL + id);
            url.searchParams.set('ps', 'default');
            url.searchParams.set('gl', 'US');
            url.searchParams.set('hl', options.lang || 'en');
            url.searchParams.set('html5', '1');
            _context9.next = 11;
            return utils.exposedMiniget(url.toString(), options).text();

          case 11:
            body = _context9.sent;
            info = querystring.parse(body);
            info.player_response = findPlayerResponse('get_video_info', info);
            return _context9.abrupt("return", info);

          case 15:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));

  return function getVideoInfoPage(_x16, _x17) {
    return _ref8.apply(this, arguments);
  };
}();
/**
 * @param {Object} player_response
 * @returns {Array.<Object>}
 */


var parseFormats = function parseFormats(player_response) {
  var formats = [];

  if (player_response && player_response.streamingData) {
    formats = formats.concat(player_response.streamingData.formats || []).concat(player_response.streamingData.adaptiveFormats || []);
  }

  return formats;
};
/**
 * Gets info from a video additional formats and deciphered URLs.
 *
 * @param {string} id
 * @param {Object} options
 * @returns {Promise<Object>}
 */


exports.getInfo = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(id, options) {
    var info, hasManifest, funcs, html5player, url, _url, results;

    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return exports.getBasicInfo(id, options);

          case 2:
            info = _context10.sent;
            hasManifest = info.player_response && info.player_response.streamingData && (info.player_response.streamingData.dashManifestUrl || info.player_response.streamingData.hlsManifestUrl);
            funcs = [];

            if (!info.formats.length) {
              _context10.next = 25;
              break;
            }

            _context10.t1 = info.html5player;

            if (_context10.t1) {
              _context10.next = 13;
              break;
            }

            _context10.t2 = getHTML5player;
            _context10.next = 11;
            return getWatchHTMLPageBody(id, options);

          case 11:
            _context10.t3 = _context10.sent;
            _context10.t1 = (0, _context10.t2)(_context10.t3);

          case 13:
            _context10.t0 = _context10.t1;

            if (_context10.t0) {
              _context10.next = 20;
              break;
            }

            _context10.t4 = getHTML5player;
            _context10.next = 18;
            return getEmbedPageBody(id, options);

          case 18:
            _context10.t5 = _context10.sent;
            _context10.t0 = (0, _context10.t4)(_context10.t5);

          case 20:
            info.html5player = _context10.t0;

            if (info.html5player) {
              _context10.next = 23;
              break;
            }

            throw Error('Unable to find html5player file');

          case 23:
            html5player = new URL(info.html5player, BASE_URL).toString();
            funcs.push(sig.decipherFormats(info.formats, html5player, options));

          case 25:
            if (hasManifest && info.player_response.streamingData.dashManifestUrl) {
              url = info.player_response.streamingData.dashManifestUrl;
              funcs.push(getDashManifest(url, options));
            }

            if (hasManifest && info.player_response.streamingData.hlsManifestUrl) {
              _url = info.player_response.streamingData.hlsManifestUrl;
              funcs.push(getM3U8(_url, options));
            }

            _context10.next = 29;
            return Promise.all(funcs);

          case 29:
            results = _context10.sent;
            info.formats = Object.values(Object.assign.apply(Object, [{}].concat(_toConsumableArray(results))));
            info.formats = info.formats.map(formatUtils.addFormatMeta);
            info.formats.sort(formatUtils.sortFormats);
            info.full = true;
            return _context10.abrupt("return", info);

          case 35:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));

  return function (_x18, _x19) {
    return _ref9.apply(this, arguments);
  };
}();
/**
 * Gets additional DASH formats.
 *
 * @param {string} url
 * @param {Object} options
 * @returns {Promise<Array.<Object>>}
 */


var getDashManifest = function getDashManifest(url, options) {
  return new Promise(function (resolve, reject) {
    var formats = {};
    var parser = sax.parser(false);
    parser.onerror = reject;
    var adaptationSet;

    parser.onopentag = function (node) {
      if (node.name === 'ADAPTATIONSET') {
        adaptationSet = node.attributes;
      } else if (node.name === 'REPRESENTATION') {
        var itag = parseInt(node.attributes.ID);

        if (!isNaN(itag)) {
          formats[url] = Object.assign({
            itag: itag,
            url: url,
            bitrate: parseInt(node.attributes.BANDWIDTH),
            mimeType: "".concat(adaptationSet.MIMETYPE, "; codecs=\"").concat(node.attributes.CODECS, "\"")
          }, node.attributes.HEIGHT ? {
            width: parseInt(node.attributes.WIDTH),
            height: parseInt(node.attributes.HEIGHT),
            fps: parseInt(node.attributes.FRAMERATE)
          } : {
            audioSampleRate: node.attributes.AUDIOSAMPLINGRATE
          });
        }
      }
    };

    parser.onend = function () {
      resolve(formats);
    };

    var req = utils.exposedMiniget(new URL(url, BASE_URL).toString(), options);
    req.setEncoding('utf8');
    req.on('error', reject);
    req.on('data', function (chunk) {
      parser.write(chunk);
    });
    req.on('end', parser.close.bind(parser));
  });
};
/**
 * Gets additional formats.
 *
 * @param {string} url
 * @param {Object} options
 * @returns {Promise<Array.<Object>>}
 */


var getM3U8 = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(url, options) {
    var body, formats;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            url = new URL(url, BASE_URL);
            _context11.next = 3;
            return utils.exposedMiniget(url.toString(), options).text();

          case 3:
            body = _context11.sent;
            formats = {};
            body.split('\n').filter(function (line) {
              return /^https?:\/\//.test(line);
            }).forEach(function (line) {
              var itag = parseInt(line.match(/\/itag\/(\d+)\//)[1]);
              formats[line] = {
                itag: itag,
                url: line
              };
            });
            return _context11.abrupt("return", formats);

          case 7:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));

  return function getM3U8(_x20, _x21) {
    return _ref10.apply(this, arguments);
  };
}(); // Cache get info functions.
// In case a user wants to get a video's info before downloading.


var _loop = function _loop() {
  var funcName = _arr[_i2];

  /**
   * @param {string} link
   * @param {Object} options
   * @returns {Promise<Object>}
   */
  var func = exports[funcName];

  exports[funcName] = /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(link) {
      var options,
          id,
          key,
          _args12 = arguments;
      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              options = _args12.length > 1 && _args12[1] !== undefined ? _args12[1] : {};
              utils.checkForUpdates();
              _context12.next = 4;
              return urlUtils.getVideoID(link);

            case 4:
              id = _context12.sent;
              key = [funcName, id, options.lang].join('-');
              return _context12.abrupt("return", exports.cache.getOrSet(key, function () {
                return func(id, options);
              }));

            case 7:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12);
    }));

    return function (_x22) {
      return _ref11.apply(this, arguments);
    };
  }();
};

for (var _i2 = 0, _arr = ['getBasicInfo', 'getInfo']; _i2 < _arr.length; _i2++) {
  _loop();
} // Export a few helpers.


exports.validateID = urlUtils.validateID;
exports.validateURL = urlUtils.validateURL;
exports.getURLVideoID = urlUtils.getURLVideoID;
exports.getVideoID = urlUtils.getVideoID;